import React from "react";
import "../../App.css";
import Footer from "../Footer";
import otaku from "../../otaku.jpg";

export default function Otaku() {
  return (
    <>
      <h1>Soon</h1>
      <img src={otaku} alt="ota" className="SOON" />
      <Footer />
    </>
  );
}
